import { viomeSmpApiInstance } from '@viome/viome-base/src/api/ApiConfig';
import type { SMPQueryParams } from '@viome/viome-base/src/usecase/SMP/SMP.model';

interface PaymentUpdateUrlResponse {
  status: number;
  message: string;
  platform: string;
  data?: { update_payment_url?: string };
}

export class PaymentUpdateUrlMissingError extends Error {
  constructor() {
    super('Payment update URL missing from response');
    this.name = 'PaymentUpdateUrlMissingError';
  }
}

/**
 * POST /app/smp-subscriptions/manage/v2/{subscriptionId}/payment_update/url
 *
 * Returns the Loop hosted-page URL for this customer. The URL embeds a
 * session token minted fresh on every call: call it on tap only, never cache
 * or reuse the result, and never log it.
 *
 * The body is required by the gateway but ignored. `smpSuccessHandler`
 * already unwraps the axios response to the JSON body.
 */
export const requestPaymentUpdateUrl = async (params: SMPQueryParams): Promise<string> => {
  const body = (await viomeSmpApiInstance.post(
    `/app/smp-subscriptions/manage/v2/${params.subscriptionId}/payment_update/url`,
    {},
    { params: { customer_id: params.customerId } },
  )) as unknown as PaymentUpdateUrlResponse;

  const url = body?.data?.update_payment_url;
  if (!url) throw new PaymentUpdateUrlMissingError();
  return url;
};
